function get(state) {
    return state.notifications;
}

export function getNotificationById(state, notificationId) {
    return get(state)[notificationId];
}

export function isExists(state, notificationId) {
    return !!getNotificationById(state, notificationId);
}
